import styles from './StyledPicker.module.scss'
import NameValue from '@/types/NameValue'
import { OptionUnstyled, SelectUnstyled, SelectValue } from '@mui/base'
import React from 'react'
import classNames from 'classnames'

type Props = {
  name: string,
  value?: string,
  placeholder?: string | null,
  options?: NameValue[],
  onChange?: (value: string | null, name: string) => void,
  disabled?: boolean,
  light?: boolean,
}

type OptionProps = {
  children: React.ReactNode,
  value: string | number,
  disabled?: boolean,
}

const StyledOption = (props: OptionProps) => {
  return (
    <OptionUnstyled
      value={props.value}
      hidden={props.value === ''}
      disabled={props.disabled}
      slotProps={{
        root: {
          className: styles.option
        }
      }}
    >
      {props.children}
    </OptionUnstyled>
  )
}

const StyledPicker = (props: Props) => {

  const onChangeHandler = (
    event: React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element> | React.FocusEvent<Element, Element> | null,
    value: string | null
  ): void => {
    if (props.onChange === undefined) return
    if (event === null) return

    props.onChange(value, props.name)
  }

  const classes = classNames(styles.component, {
    [styles.light]: props.light,
  })

  return (
    <div className={classes}>
      <SelectUnstyled
        name={props.name}
        value={props.value}
        disabled={props.disabled}
        onChange={onChangeHandler}
        slotProps={{
          root: {
            className: styles.root
          },
          listbox: {
            className: styles.listbox
          },
          popper: {
            className: styles.popper
          }
        }}
      >
        {props.placeholder !== undefined && props.placeholder !== null && props.placeholder !== '' && (
          <StyledOption value="" disabled>{props.placeholder}</StyledOption>
        )}
        {
          props.options?.map((option, index) => (
            <StyledOption
              key={index}
              value={option.value}
            >{option.name}
            </StyledOption>
          ))
        }
      </SelectUnstyled >
    </div>
  )
}

export default StyledPicker